import { render, staticRenderFns } from "./Maker.vue?vue&type=template&id=64715b66&scoped=true"
import script from "./Maker.vue?vue&type=script&lang=js"
export * from "./Maker.vue?vue&type=script&lang=js"
import style0 from "./Maker.vue?vue&type=style&index=0&id=64715b66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64715b66",
  null
  
)

export default component.exports